import React from 'react';
import _get from 'lodash/get';
import Constants from '../../data/constants';

/**
 * 4 states:
 *
 * 1. Show placeholder image
 * 2. Show uploaded image
 * 3. Show uploaded filename
 * 4. Show error msg.
 *
 * @param fileInfo
 * @param fileContents
 * @param fallbackImage
 * @returns {JSX.Element}
 * @constructor
 */
const FilePreview = ({
    fileInfo = null,
    fileContents = null,
    placeholderImage,
}) => {
    const allowedPreviewTypes = Constants().ALLOWED_PREVIEW_FILE_TYPES;
    const fileName = _get(fileInfo, 'name', null);
    const fileType = _get(fileInfo, 'type', null);

    if (fileContents && allowedPreviewTypes.includes(fileType)) {
        // Show preview
        return (
            <div className="dl-img" style={{backgroundImage: `url("${fileContents}")`}} />
        );
    } else if (fileContents && fileName) {
        // Show filename
        return (
            <div className="dl-img">
                <span>{fileName}</span>
            </div>
        );
    } else if (fileName && !fileContents) {
        // Show error
        return (
            <div className="dl-img">
                <span>Invalid file type</span>
            </div>
        );
    }

    // Show placeholder
    return (
        <div className="dl-img" style={{backgroundImage: `url("${placeholderImage}")`}} />
    );
}

export default FilePreview;